// 全局函数
const Shopify_Url = window.Shopify.routes.root;
const AlpFn = {
  // 更新购物车数量显示
  UpdateCartCount: function () {
    axios.get(Shopify_Url + "cart.js").then(function (response) {
      let count = response.data.item_count;
      $("cart-count.bubble-count").each(function () {
        $(this).html(count);
      });
    });
  },
  AddToCartOne: async function (variants) {
    // variants should be string like "1,2,3"
    let $variants = variants;
    let idStrings = $variants.split(",").filter(Boolean);
    if (idStrings.length < 1) {
      return false;
    }
    let resultArray = idStrings.map((id) => ({
      id: Number(id),
      quantity: 1,
    }));
    let formData = {
      items: resultArray,
    };
    let formDataString = JSON.stringify(formData);
    let response = await fetch(Shopify_Url + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: formDataString,
    });
    this.UpdateCartCount();
    return response;
  },
};

// kits and bundle accessories add to cart functions
async function alpProductBundleToCart() {
  let $variants_all = "";
  let $kits_variants_els = $(`[data-variants].active`);
  $kits_variants_els.each(function () {
    let $this = $(this);
    let $this_variants = $this.attr("data-variants");
    $variants_all += `${$this_variants}`;
  });
  let $res = await AlpFn.AddToCartOne($variants_all);
  if ($res) {
    console.log("bundle added to cart");
  } else {
    console.log("no bundle added to cart");
  }
  $(`.alp-addtocart-btn [type="submit"]`).trigger("click");
}
async function alpProductBundleToCart2() {
  let $variants_all = "";
  let $kits_variants_els = $(`[data-variants].active`);
  $kits_variants_els.each(function () {
    let $this = $(this);
    let $this_variants = $this.attr("data-variants");
    $variants_all += `${$this_variants}`;
  });
  let $res = await AlpFn.AddToCartOne($variants_all);
  if ($res) {
    console.log("bundle added to cart");
  } else {
    console.log("no bundle added to cart");
  }
}
function MyMyAddCartBtn() {
  $(".alp-addtocart-btn").append(`<div class="alp-mymy-cart-btn"></div>`);
  let $fakeBtn = $(".alp-addtocart-btn .alp-mymy-cart-btn");
  $fakeBtn.on("click", function () {
    alpProductBundleToCart();
  });
}

function WatchTheParams_for_Product_form() {
  let params = new URLSearchParams(window.location.search);
  let variant_id = params.get("variant");
  if (variant_id) {
    let href = window.location.href;
    $(".alp-product-price").load(`${href} .alp-product-price > div`);
  }
}
let currentURL = window.location.href;
setInterval(() => {
  let newURL = window.location.href;
  if (newURL !== currentURL) {
    currentURL = newURL;
    WatchTheParams_for_Product_form();
  }
}, 300);

$(function () {
  MyMyAddCartBtn();
});
